import { useRef } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { patchCachedItem } from "@/lib/cache";
import { useEditGate } from "@/components/EditGate";
import { TagPicker } from "./TagPicker";

export const InlineTags = ({ item, collection = "recipes", testid, disabled, onSaved }) => {
  const { requireEdit } = useEditGate();
  const password = useRef(null);
  const open = callback => requireEdit(pw => { password.current = pw; callback(); }, true);
  const save = async tags => {
    const { data } = await api.patch(`/${collection}/${item.id}/tags`, { tags, password: password.current });
    patchCachedItem(collection, data);
    onSaved?.(data);
    toast.success("Tags saved");
  };
  return <TagPicker compact testid={testid} value={item.tags || []} onSave={save} disabled={disabled} requestOpen={open} />;
};